import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import SoftBox from "components/SoftBox";
import SoftButton from "components/SoftButton";
import Card from "@mui/material/Card";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { useParams, useNavigate } from "react-router-dom";
import AlertMessage from "components/UI/AlertMessage";
import useAlert from "hooks/useAlert";
import Unauthorized from "components/UI/Unauthorized";
import { usePermissions } from "context/PermissionsContext";
import JobRecords from "./JobRecords";
import { t } from "i18next";

const JobClassicDetail = () => {
  const { jobName } = useParams();
  const { errorState } = useAlert();
  const navigate = useNavigate();
  const { hasPermission } = usePermissions();

  if (!hasPermission("can_view_gwm")) {
    return <Unauthorized />;
  }

  const displayName = jobName
    ? jobName
        .split("_")
        .map((w) => w.charAt(0).toUpperCase() + w.slice(1))
        .join(" ")
    : "Job Records";

  const pagesList = [
    { name: t("lang.jobs") || "Jobs", route: "/jobs" },
    { name: displayName, route: "" },
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar pagesList={pagesList} />
      <Card sx={{ mt: 2 }}>
        <SoftBox p={3}>
          <JobRecords jobName={decodeURIComponent(jobName)} />
        </SoftBox>
      </Card>
      <SoftBox display="flex" justifyContent="flex-start" mt={2}>
        <SoftButton
          variant="contained"
          startIcon={<ArrowBackIcon />}
          color="dark"
          onClick={() => navigate("/jobs")}
        >
          {t("lang.actions.back") || "Back"}
        </SoftButton>
      </SoftBox>
      <AlertMessage {...errorState} />
    </DashboardLayout>
  );
};

export default JobClassicDetail;
